import { Preferences } from "../../profile/objects/preferences";
import { DESTINATION_PARAMS_MODULE, DEFAULT_COLUMN } from "../constant/destinationParamsConstant";
import { Column } from "../objects/column";
import { setListPreference, ListPreferenceResult } from "../../utils/list/utils/setListPreference";

export const setDestinationParamsPreference = (new_preferences: Preferences[], state_columns: Column[]): ListPreferenceResult =>
    setListPreference(new_preferences, state_columns, {
        module: DESTINATION_PARAMS_MODULE,
        default_columns: DEFAULT_COLUMN,
        default_order_by: '',
        default_order: 'asc',
    });